import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLandroverComponent } from './simple-icons-landrover.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLandroverComponent ],
    exports:      [ SimpleIconsLandroverComponent ],
    bootstrap:    []
})
export class SimpleIconsLandroverModule {}
